module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_6000.e70175b3.png";